export default "__VITE_ASSET__DT_B8Qtf__"